import React from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";
import { PolicyReportMappingEnum } from "../../enum/normalization-mapping.enum.ts";
import moment from "moment/moment";

interface PoliciesReportDataGridProps {
  policies: any[];
  isLoading: boolean;
  selectedPolicies: Set<string>;
  setSelectedPolicies: React.Dispatch<React.SetStateAction<Set<string>>>;
}

const ReportedPoliciesDataGrid: React.FC<PoliciesReportDataGridProps> = ({
  policies,
  isLoading,
}) => {
  const columns = [
    {
      name: PolicyReportMappingEnum.Pol_Num,
      header: "№ Полица",
      minWidth: 140,
      type: "string",
    },
    {
      name: PolicyReportMappingEnum.InsComp,
      header: "ЗК",
      minWidth: 150,
      type: "string",
    },
    {
      name: PolicyReportMappingEnum.Pol_Kind,
      header: "Вид Полица",
      minWidth: 150,
      type: "string",
    },
    {
      name: PolicyReportMappingEnum.Office,
      header: "Офис",
      minWidth: 120,
      type: "string",
    },
    {
      name: PolicyReportMappingEnum.Sum,
      header: "Сума",
      minWidth: 100,
      type: "number",
    },
    {
      name: PolicyReportMappingEnum.StartDate,
      header: "От дата",
      minWidth: 120,
      type: "date",
    },
    {
      name: PolicyReportMappingEnum.EndDate,
      header: "До дата",
      minWidth: 120,
      type: "date",
    },
    {
      name: PolicyReportMappingEnum.DocDate,
      header: "Дата на сключване",
      minWidth: 120,
      type: "string",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={policies}
      isLoading={isLoading}
      gridTitle="Отчетени полици в ЗК"
      idProperty={PolicyReportMappingEnum.Pol_ID}
      csvFilename={`Отчетени-Полици-ЗК-${moment().format("DD-MM-YYYY")}`}
      icon="fa-kit fa-regular-file-circle-question"
      editable={false}
    />
  );
};

export default ReportedPoliciesDataGrid;
